// extracted by mini-css-extract-plugin
export default {"box":"error_box__ts2bv","errorText":"error_errorText__3iC5X","errorIcon":"error_errorIcon__u4uqV"};